import React from "react";
import { useParams } from "react-router-dom";
import HeaderLogged from "../components/HeaderLogged";
import Footer from "../components/Footer";
import CompanyDetailsContent from "./CompanyDetailsContent";

function CompanyDetails() {
  const { id } = useParams();

  return (
    <div className="flex flex-col min-h-screen bg-[#E4F2FF]">
      <HeaderLogged />

      <main className="flex-1 p-4">
        <CompanyDetailsContent companyId={id} />
      </main>

      <Footer />
    </div>
  );
}

export default CompanyDetails;
